module.exports = __webpack_public_path__ + "assets/img/zh-Hant-c69e8338.png";